import React from 'react'
import RangeSlider from './RangeSlider'
import { translate } from '../Services/translation'
import constants from '../constants'

export default function TireSerachDrawer({filters, onFacetChange, showDrawer, handleCloseSearchDrawer, totalHits, vehicleData}) {
    const handleChangeTyreType = (event, tyreTypeFilter, winterFilter) => {
        let selectedOption = event.target.selectedOptions[0]
        let type = selectedOption.dataset.type

        if(type === constants.filterTags.tireType) {
            let callback = () => onFacetChange(winterFilter, null, true, null, true)
            onFacetChange(tyreTypeFilter, selectedOption.value, false, callback, true)
            return
        }

        let callback = () => {
            onFacetChange(tyreTypeFilter, filters[constants.filterTags.tireType].options.find(option => option.cssValue == "wintertire").id, true, null, true)
        }
        onFacetChange(winterFilter, selectedOption.value, false, callback, true)
    }

    const handleChangeVehicleSize = (index) => {
        const selectedSize = vehicleData.tires[index]
        if(selectedSize == null) return

        const width = selectedSize.width
        const diameter = selectedSize.diameter
        const profile = selectedSize.profile

        onFacetChange(filters[constants.filterTags.widthInMm], width, false, () => {
            onFacetChange(filters[constants.filterTags.diameter], diameter, false, () => {
                onFacetChange(filters[constants.filterTags.height], profile, true, null, true)
            }, true)
        }, true)

    }

    const getSelectedSizeIndex = () => {
        const width = filters[constants.filterTags.widthInMm]?.selectedOptions[0]
        const diameter = filters[constants.filterTags.diameter]?.selectedOptions[0]
        const height = filters[constants.filterTags.height]?.selectedOptions[0]
        const index = vehicleData.tires.findIndex(tire => 
            tire.width == width && tire.diameter == diameter && tire.profile == height
        )

        return index
    }

    const getTireSizeString = (tire) => `${tire?.width}/${tire?.profile}R${tire?.diameter} ${!tire.isFront ? translate("facet.onlyrear") : ""}`

    return (
        <div 
            className={`drawer-container ${showDrawer && "drawer-container--show"}`}>
                <span onClick={handleCloseSearchDrawer} className="icon-close">
                </span>
                <div className="drawer-content">
                    <h3>{translate("facet.header.changesearch")}</h3>
                    {!!vehicleData ? 
                        (
                            <div className="filter-row">
                                <b>{translate("facet.header.size")}</b>
                                <select onChange={(event) => handleChangeVehicleSize(event.target.value)} value={getSelectedSizeIndex()}>
                                    {vehicleData.tires.map((tire, index) => (
                                        <option value={index} key={getTireSizeString(tire)}>
                                            {getTireSizeString(tire)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ) :
                        (
                            <div className="size-filter-no-car filter-row">
                                {[filters[constants.filterTags.widthInMm], filters[constants.filterTags.height], filters[constants.filterTags.diameter]].filter(filter => filter != null).map(filter => 
                                    (
                                        <div key={filter.id}>
                                            <b>{filter.label}</b>
                                            <select value={filter.selectedOptions[0]} onChange={e => onFacetChange(filter, e.target.value, true, null, true)}>
                                                <option></option>
                                                {filter.options.map(option => (
                                                    <option key={option.id}>{option.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )
                                )}
                            </div>
                        )
                    }
                    <div className="filter-row">
                        <b>{translate("facet.header.tiretype")}</b>
                        <select value={filters[constants.filterTags.winterTireType]?.selectedOptions[0] ?? filters[constants.filterTags.tireType]?.selectedOptions[0]} 
                            onChange={e => handleChangeTyreType(e, filters[constants.filterTags.tireType], filters[constants.filterTags.winterTireType])}>
                            {[filters[constants.filterTags.tireType], filters[constants.filterTags.winterTireType]]
                                .map(filter => filter?.options.filter(option => !!option.id).map(option => (
                                    <option value={option.id} data-type={filter.id} key={option.id}>{option.label}</option>
                                )
                            ))}
                        </select>
                    </div>
                    {[filters[constants.filterTags.brand], filters[constants.filterTags.speedRating], filters[constants.filterTags.loadIndex]].filter(x => x != null).map(filter => (
                        <div className="filter-row" key={filter.id}>
                            <b>{filter.label}</b>
                            <div className="side-scroll-filter">
                                {filter.options.filter(option => option.quantity > 0).map(option => (
                                    <button 
                                        key={option.id}
                                        className={filter.selectedOptions.some(x => x === option.id) ? "active" : ""} 
                                        onClick={() => onFacetChange(filter, option.id, true)}>
                                        {option.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                    <div className="filter-row">
                        <b>{translate("facet.header.price")}</b>
                        <RangeSlider 
                            filter={filters.price_range}
                            onFacetChange={onFacetChange}
                        />
                    </div>
                </div>
                <div className="show-result-button-container">
                    <button onClick={handleCloseSearchDrawer} className="show-result-button">
                        {translate("facet.showhits")} {totalHits && <>({totalHits})</>}
                    </button>
                </div>
        </div>
    )
}